import Tabs from '@pratt/js/components/tabs';

class ProgramTabs {
  constructor(rootEl) {
    this.rootEl = rootEl;
    if (!this.rootEl) {
      throw new Error('Root program tabs element not found.');
    }

    const isFilterable = this.rootEl.dataset['filterable'];

    this.tabs = new Tabs(this.rootEl, 'horizontal', !!isFilterable);

    if (isFilterable) {
      this.departmentSelect = this.rootEl.querySelector('.js-program-tabs-departments-select');
      this.filterReset = this.rootEl.querySelector('.js-program-tabs-departments-clear');
      this.schoolSections = this.rootEl.querySelectorAll('.archive-programs__school-section');
      this.programs = this.rootEl.querySelectorAll('.archive-programs__school-item');
      this.programSections = this.rootEl.querySelectorAll('.archive-programs__programs-section');

      const urlParams = new URLSearchParams(window.location.search);
      this.schoolSlugToFilter = urlParams.get('school');
      this.departmentSlugToFilter = urlParams.get('department');

      this.bindEvents();
      this.filter();
    }
  }

  bindEvents() {
    this.filterReset.addEventListener('click', () => {
      this.tabs.resetTabs();
      window.history.pushState({}, '', `${window.location.origin}${window.location.pathname}`);
      this.schoolSlugToFilter = null;
      this.departmentSlugToFilter = null;
      this.filter();
    });

    this.departmentSelect.addEventListener('change', e => {
      let optionValue = e.target.value;
      if (!optionValue) {
        optionValue = `${window.location.origin}${window.location.pathname}`;
      }
      window.history.pushState({}, '', `${optionValue}${window.location.hash}`);
      const params = new URLSearchParams(optionValue);
      this.schoolSlugToFilter = params.get('school');
      this.departmentSlugToFilter = params.get('department');
      this.filter();
    });
  }

  filter() {
    if (this.schoolSlugToFilter || this.departmentSlugToFilter) {
      this.filterReset.removeAttribute('disabled');
    } else {
      this.filterReset.setAttribute('disabled', '');
    }

    this.departmentSelect.value =
      this.schoolSlugToFilter && this.departmentSlugToFilter
        ? `?school=${this.schoolSlugToFilter}&department=${this.departmentSlugToFilter}`
        : '';

    this.schoolSections.forEach(section => {
      section.removeAttribute('hidden');

      if (this.schoolSlugToFilter) {
        const schoolSlug = section.dataset['school'];
        if (schoolSlug !== this.schoolSlugToFilter) {
          section.setAttribute('hidden', '');
        }
      }
    });

    this.programs.forEach(program => {
      program.removeAttribute('hidden');

      if (this.departmentSlugToFilter) {
        const departmentSlug = program.dataset['department'];
        if (departmentSlug !== this.departmentSlugToFilter) {
          program.setAttribute('hidden', '');
        }
      }
    });

    this.programSections.forEach(section => {
      const emptyText = section.querySelector('.archive-programs__empty');
      emptyText.setAttribute('hidden', '');

      const programs = Array.from(section.querySelectorAll('.archive-programs__school-item'));
      const shownPrograms = programs.filter(program => !program.hasAttribute('hidden'));

      // If all programs items are hidden, show empty text
      if (!shownPrograms.length) {
        emptyText.removeAttribute('hidden');
      }
    });
  }
}

export default ProgramTabs;
